<template>
  <div class="summary-display-input clearfix">
    <div class="form-group row">
      <responsive-table :table="table"></responsive-table>
    </div>
  </div>
</template>

<script>
import ResponsiveTable from '../ResponsiveTable'
import Util from '@server/util'

export default {
  name: 'SummaryDisplayInput',
  components: {
    ResponsiveTable
  },
  props: {
    options: {
      type: Object
    }
  },
  computed: {
    table () {
      return {
        title: 'Summary of Charges',
        count: 0,
        columns: this.columns,
        rows: this.rows
      }
    }
  },
  data () {
    return {
      isValid: true,
      rows: [],
      columns: [
        { title: 'Description', span: 6, name: 'description', type: 'text' },
        { title: 'Amount', span: 6, name: 'amount', type: 'currency' }
      ]
    }
  },
  methods: {
    updateRows (charges) {
      this.rows = []
      let total = 0
      for (let charge of charges) {
        if (charge) {
          let row = {}
          if (charge.amountValue && charge.descriptionValue) {
            row.description = charge.descriptionValue
            row.amount = Util.round(charge.amountValue)
            total += row.amount
            this.rows.push(row)
          } else {
            let muaCharge = this.options.muaCharges.find(function (el) {
              return el.uuid === charge
            })
            if (muaCharge) {
              row.description = muaCharge.name
              row.amount = Util.round(muaCharge.cost)
              total += row.amount
              this.rows.push(row)
            }
          }
        }
      }
      this.rows.push({
        description: 'Total (Includes GST)',
        amount: total
      })
    },
    runWatcher (val, name) {
      switch (name) {
        case 'charges':
          this.updateRows(val)
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/SummaryDisplayInput.vue